var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.84615 0C1.73079 0 0 1.73079 0 3.84615V16.1538C0 18.2692 1.73079 20 3.84615 20H16.1538C18.2692 20 20 18.2692 20 16.1538V3.84615C20 1.73079 18.2692 0 16.1538 0H3.84615ZM3.84615 1.53846H16.1538C17.4385 1.53846 18.4615 2.56152 18.4615 3.84615V16.1538C18.4615 17.4385 17.4385 18.4615 16.1538 18.4615H13.6989V12.2566H15.8474L16.1689 9.78065H13.6989V8.20312C13.6989 7.4862 13.8985 6.9982 14.9339 6.9982H16.256V4.78365C16.0268 4.75288 15.2422 4.6875 14.3299 4.6875C12.4253 4.6875 11.1238 5.83981 11.1238 7.95673V9.78065L9.23077 9.77464V12.2506L11.1238 12.2566V18.4615H3.84615C2.56152 18.4615 1.53846 17.4385 1.53846 16.1538V3.84615C1.53846 2.56152 2.56152 1.53846 3.84615 1.53846Z",
    fill: "#EAE7E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.30d990bad4518416fb416c6e4fd264d5.svg";
export { ForwardRef as ReactComponent };